/**
 * Makes a palette colour see-through. Only for surfaces that genuinely have to
 * let what is behind them show — an overlay, a scrim, chrome floating over a
 * photo. A tint on a known background is an opaque palette step instead, or the
 * same colour renders differently on every surface it lands on.
 *
 * Web and `apps/learn` say this with Tailwind's `/xx` modifier; this helper is
 * for `apps/capture` and the styled-components primitives, which have no
 * classes. React Native accepts the `rgba()` string it returns.
 */
export const withAlpha = (color: string, alpha: number) => {
  const hex = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(color)?.[1];
  if (!hex) {
    throw new Error(`withAlpha expects a hex colour, got "${color}"`);
  }

  const full =
    hex.length === 3
      ? hex
          .split('')
          .map((digit) => digit + digit)
          .join('')
      : hex;

  const [r, g, b] = [0, 2, 4].map((offset) =>
    parseInt(full.slice(offset, offset + 2), 16),
  );

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
